(function() {
  var box = document.getElementById('buy-box');
  if (!box) return;

  var dragging = false, lastX = 0, lastY = 0;
  var rotY = parseFloat(box.dataset.rotY);
  var rotX = parseFloat(box.dataset.rotX);
  var dragEndAt = 0;
  var AUTO_SPEED = 16; // deg/sec, matches the 3D model viewers elsewhere on site
  var AUTO_RESUME_DELAY = 1000;

  var apply = function() { box.style.transform = 'rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)'; };
  apply();

  var start = function(e) {
    dragging = true; box.classList.add('dragging');
    var p = e.touches ? e.touches[0] : e;
    lastX = p.clientX; lastY = p.clientY; e.preventDefault();
  };
  var move = function(e) {
    if (!dragging) return;
    var p = e.touches ? e.touches[0] : e;
    var dx = p.clientX - lastX, dy = p.clientY - lastY;
    rotY += dx * 0.65; rotX -= dy * 0.4;
    rotX = Math.max(-35, Math.min(35, rotX));
    apply(); lastX = p.clientX; lastY = p.clientY;
  };
  var end = function() {
    if (!dragging) return;
    dragging = false; box.classList.remove('dragging');
    dragEndAt = performance.now();
  };
  box.addEventListener('mousedown', start);
  box.addEventListener('touchstart', start, { passive: false });
  document.addEventListener('mousemove', move);
  document.addEventListener('touchmove', move, { passive: false });
  document.addEventListener('mouseup', end);
  document.addEventListener('touchend', end);

  var lastAutoTs = null;
  function autoRotateTick(ts) {
    if (!dragging && (ts - dragEndAt) > AUTO_RESUME_DELAY) {
      if (lastAutoTs != null) {
        rotY += AUTO_SPEED * (ts - lastAutoTs) / 1000;
        apply();
      }
      lastAutoTs = ts;
    } else {
      lastAutoTs = null;
    }
    requestAnimationFrame(autoRotateTick);
  }
  requestAnimationFrame(autoRotateTick);
})();
